/**
 * Utility functions for formatting text content
 */

/**
 * Converts newline characters to HTML <br> tags for rendering
 * This allows users to press Enter in textareas and have line breaks display correctly
 *
 * @param text - The text string that may contain newline characters (\n)
 * @returns HTML string with <br /> tags
 *
 * @example
 * renderTextWithLineBreaks("Hello\nWorld") // Returns "Hello<br />World"
 */
export const renderTextWithLineBreaks = (text: string | undefined | null): string => {
  if (!text) return '';

  // Replace newline characters with <br /> tags
  // This is safe because we're not accepting user HTML, just converting newlines
  return text.replace(/\n/g, '<br />');
};

/**
 * Sanitizes text by removing any HTML tags except <br />
 * Use this as an extra safety layer if needed
 *
 * @param text - The text to sanitize
 * @returns Sanitized text with only <br /> tags allowed
 */
export const sanitizeText = (text: string | undefined | null): string => {
  if (!text) return '';

  // Remove all HTML tags except <br> and <br/>
  return text.replace(/<(?!\/?br\s*\/?>)[^>]+>/gi, '');
};
